export const RRS_SAVE_OR_REPAY_LOAN = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Lønner det seg å spare eller nedbetale lån?',
  url: 'https://scoopr.no/lonner-det-seg-a-spare-eller-nedbetale-lan',
  description:
    'Det er alltid smart å ha penger i bakhånd, slik at du ikke behøver å bruke kredittkortet eller ta opp et lån når det kommer uforutsette utgifter. Men hvor mye penger bør du ha, og bør du prioritere å spare eller betale på lånene dine? Og hvilke lån bør du nedbetale først?',
  datePublished: '2022-02-09T08:00:00+00:00',
  dateModified: '2022-02-09T08:00:00+00:00',
};
